import { service } from '@ember/service'
import { RolloverStep } from 'teacher-ui-client/school-rollover/steps'
import StepRoute from 'teacher-ui-client/manage/rollover/steps/step-route'
import type { IntlService } from 'ember-intl'
import type DeleteClassesController from 'teacher-ui-client/manage/rollover/steps/delete-classes/controller'

export default class DeleteClassesRoute extends StepRoute {
  @service intl!: IntlService

  queryParams = {
    pageNumber: {
      replace: true,
    },
    perPage: {
      replace: true,
    },
    selected: {
      replace: true,
    },
    sort: {
      replace: true,
    },
  }

  setupController(controller: DeleteClassesController, model: ModelFor<StepRoute>) {
    super.setupController(controller, model)
    void controller.fetchPreRolloverClasses.perform()
  }

  /**
   * @property stepId used by {StepRoute} to save the furthest step visited.
   */
  stepId = RolloverStep.DeleteClasses

  buildRouteInfoMetadata() {
    let title = this.intl.t('manage.rollover.title')
    if (this.intl.exists(`manage.rollover.steps.${this.stepId}.title`)) {
      title = this.intl.t(`manage.rollover.steps.${this.stepId}.title`)
    }
    return { stepId: this.stepId, title }
  }
}
